import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import About from '@/components/About'
import Setting from '@/components/Setting'
import Login from '@/components/Login'
import User from '@/components/User'
import Navigation from '@/components/Navigation'
import NavigationList from '@/components/NavigationList'

Vue.use(Router)

export default new Router({
  mode: 'history', // 这种模式在URL中不会显示#
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/nav/list',
      name: 'NavigationList',
      component: NavigationList
    },
    {
      path: '/nav/:nid',
      name: 'Navigation',
      component: Navigation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js